/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("DriverEditCtrl", [
		"$routeParams", "$scope", "$location", "Utils", "driver", "mode", "companies", "$uibModal", "toastr", "DriverService",
		function ($routeParams, $scope, $location, Utils, driver, mode, companies, $uibModal, toastr, DriverService) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			driver: driver.data,
			mode: mode,
			companies: companies.data
		};


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/


		$scope.post = function () {

			if ($scope.data.mode === "new") {

				DriverService.addDriver($scope.data.driver).then(() => {
					toastr.success("", "Conducteur créé");
					$location.path("/manager/drivers");
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la création du conducteur. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				DriverService.editDriver($routeParams.id, $scope.data.driver).then((response) => {
					const data = response.data;
					toastr.success("", "Le conducteur " + data.name + " a été mis à jour");
					$scope.data.driver = data;
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour du conducteur. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


	}]
	)
;